import { render, staticRenderFns } from "./dialogTemplate.vue?vue&type=template&id=516f2d18&"
import script from "./dialogTemplate.vue?vue&type=script&lang=js&"
export * from "./dialogTemplate.vue?vue&type=script&lang=js&"
import style0 from "./dialogTemplate.vue?vue&type=style&index=0&id=516f2d18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports